import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GridColumnDef } from './grid-types';

@Component({
  selector: 'wc-column-chooser',
  standalone: false,
  styleUrls: ['./grid-theme.css'],
  template: `
  <div class="wcg-flyout">
  <div class="wcg-flyout__header">
    <strong>Columns</strong>
    <span class="wcg-flyout__spacer"></span>
    <button class="wcg-btn wcg-btn--ghost" (click)="close.emit()">Close</button>
  </div>

  <div class="wcg__muted wcg-flyout__hint">
    Toggle which columns are visible (saved per grid in localStorage).
  </div>

  <div class="wcg-flyout__list">
    <label class="wcg-flyout__item" *ngFor="let c of columns">
      <input type="checkbox"
             [(ngModel)]="checked[c.field]"
             (ngModelChange)="emit()" />
      <span>{{c.header}}</span>
    </label>
  </div>

  <div class="wcg-flyout__footer">
    <button class="wcg-btn wcg-btn--ghost" (click)="selectAll()">All</button>
    <button class="wcg-btn wcg-btn--ghost" (click)="selectNone()">None</button>
  </div>
</div>

  `
})
export class WcColumnChooserComponent {
  @Input() columns: GridColumnDef[] = [];
  @Input() visible: string[] = [];

  @Output() visibleChange = new EventEmitter<string[]>();
  @Output() close = new EventEmitter<void>();

  checked: Record<string, boolean> = {};

  ngOnChanges(): void {
    this.checked = {};
    for (const c of this.columns) this.checked[c.field] = this.visible.includes(c.field);
  }

  emit() {
    const v = this.columns.filter(c => this.checked[c.field]).map(c => c.field);
    this.visibleChange.emit(v);
  }

  selectAll() {
    for (const c of this.columns) this.checked[c.field] = true;
    this.emit();
  }

  selectNone() {
    for (const c of this.columns) this.checked[c.field] = false;
    this.emit();
  }
}
